import { pdfjs } from 'react-pdf/dist/umd/entry.webpack';

class PdfParser {

  constructor(file: File) {
    this.file = file;
  }

  getPdf = (): Promise<Object> => new Promise((res, rej) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      // TODO: Fix flow error. e.target.result is not in the flowtype, but does exist in FileReader API.
      // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/onload
      // $FlowFixMe
      const arrayBuffer = new Uint8Array(e.target.result);
      const loadingTask = pdfjs.getDocument(arrayBuffer);
      loadingTask.promise
        .then(pdf => res(pdf))
        .catch(err => rej(err));
    };

    fileReader.readAsArrayBuffer(this.file);
  });

  file: File;

}

export default PdfParser;
